// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  const token = localStorage.getItem('token');
  return request<{
    data: API.CurrentUser;
  }>('/api/auth/me', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/auth/logout */
export async function outLogin(options?: { [key: string]: any }) {
  localStorage.removeItem('token');
  return { success: true };
}

/** 邮箱登录接口 POST /api/auth/login/email */
export async function loginByEmail(body: { email: string; password: string }, options?: { [key: string]: any }) {
  const response = await request<{
    access_token: string;
    user: API.CurrentUser;
  }>('/api/auth/login/email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      email: body.email,
      password: body.password,
    },
    ...(options || {}),
  });

  // 保存 token
  if (response.access_token) {
    localStorage.setItem('token', response.access_token);
  }

  return {
    status: 'ok',
    type: 'account',
    currentAuthority: 'admin',
  };
}

/** 手机号登录接口 POST /api/auth/login/phone */
export async function loginByPhone(body: { phone: string; password: string }, options?: { [key: string]: any }) {
  const response = await request<{
    access_token: string;
    user: API.CurrentUser;
  }>('/api/auth/login/phone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      phone: body.phone,
      password: body.password,
    },
    ...(options || {}),
  });

  // 保存 token
  if (response.access_token) {
    localStorage.setItem('token', response.access_token);
  }

  return {
    status: 'ok',
    type: 'account',
    currentAuthority: 'admin',
  };
}

/** 登录接口 POST /api/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  const response = await request<{
    access_token: string;
    user: API.CurrentUser;
  }>('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      username: body.username,
      password: body.password,
    },
    ...(options || {}),
  });

  // 保存 token
  if (response.access_token) {
    localStorage.setItem('token', response.access_token);
  }

  return {
    status: 'ok',
    type: 'account',
    currentAuthority: 'admin',
  };
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
